import axiosIns from '@/api/axios'
import axiosInsAcademy from '@/api/axios-ugems-academy';


export const GET_EMPLOYEE = (args) => {
    return axiosIns.get(`/master-data/employee?`, { params: args });
}

// Search employees by NIK or Full Name
export const SEARCH_EMPLOYEES = (searchQuery) => {
    return axiosInsAcademy.get(`/employees/search`, { params: { search: searchQuery } });
}

